import { useParams } from 'react-router';

export function useSimulationInfo():
  | { isSimulation: true; simulationId: string }
  | { isSimulation: false; simulationId: undefined } {
  const { simulationId } = useParams();

  return simulationId
    ? {
        isSimulation: true,
        simulationId,
      }
    : {
        isSimulation: false,
        simulationId: undefined,
      };
}
